<template>
    <div class="welcome">
        <div class="quickly quickly-inner">
            <div class="btnList">
                <Permission allowed="business.site-subways">
                    <div class='items' @click="$router.push({path: '/operation/subway/list'})">
                        <div>
                             <i class="iconfont">&#xe67d;</i>
                        </div>
                        <span class="name">地铁线管理</span>
                    </div>
                </Permission>
                <Permission allowed="operating.news-categories.list">
                    <div class='items' @click="$router.push({path: '/operation/news-categories/list'})">
                        <div>
                             <i class="iconfont">&#xe691;</i>
                        </div>
                        <span class="name">资讯分类列表</span>
                    </div>
                </Permission>
                <!-- <Permission allowed="operating.form-channels.list">
                    <div class='items' @click="$router.push({path: '/operation/form-channels/list'})">
                        <div>
                             <i class="iconfont">&#xe67f;</i>
                        </div>
                        <span class="name">推广渠道列表</span>
                    </div>
                </Permission> -->
                <Permission allowed="operating.feedbacks.list">
                    <div class='items' @click="$router.push({path: '/operation/feedbacks/list'})">
                        <div>
                             <i class="iconfont">&#xe686;</i>
                        </div>
                        <span class="name">意见反馈列表</span>
                    </div>
                </Permission>
                 <Permission allowed="operating.calculator">
                    <div class='items' @click="$router.push({path: '/operation/calputer/list'})">
                        <div>
                             <i class="iconfont">&#xe67e;</i>
                        </div>
                        <span class="name">贷款利率配置</span>
                    </div>
                </Permission>
                 <Permission allowed="ad.ad-page.list">
                    <div class='items' @click="$router.push({path: '/operation/ad/page/list'})">
                        <div>
                             <i class="iconfont">&#xe67c;</i>
                        </div>
                        <span class="name">广告页面列表</span>
                    </div>
                </Permission>
                <Permission allowed="operating.wikipedia.wikipedia-list.list">
                    <div class='items' @click="$router.push({path: '/operation/baike/index'})">
                        <div>
                             <i class="iconfont">&#xe678;</i>
                        </div>
                        <span class="name">百科列表</span>
                    </div>
                </Permission>
                 <Permission allowed="operating.topic.list">
                    <div class='items' @click="$router.push({path: '/operation/topic/list'})">
                        <div>
                             <i class="iconfont">&#xe68c;</i>
                        </div>
                        <span class="name">专题列表</span>
                    </div>
                </Permission>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'OperateWelcome'
}
</script>
<style scoped lang="less">
@import url('../../../assets/style/welcome.less');
</style>